import { UPDATE_DISTRIBUTION_FORM_REDIRECTION } from '../constants/distribution';

export const redirectToDistribution = (value) => async (dispatch) => {
  if (value) {
    await dispatch({
      type: UPDATE_DISTRIBUTION_FORM_REDIRECTION,
      payload: value
    });
  }
};
